export default "__VITE_ASSET__CUP0uaVG__"